import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

export const usePreserveScroll = () => {
  const router = useRouter();
  const scrollPositions = useRef<Record<string, number>>({});
  const isBack = useRef(false);

  useEffect(() => {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    router.beforePopState(() => {
      isBack.current = true;
      return true;
    });

    const onRouteChangeStart = () => {
      const url = router.asPath;
      scrollPositions.current[url] = window.scrollY;
    };

    const onRouteChangeComplete = (url: string) => {
      url = stripLocale(url, router.locale!);

      if (isBack.current && scrollPositions.current[url]) {
        window.scroll({
          top: scrollPositions.current[url],
          behavior: 'auto',
        });
      }

      isBack.current = false;
    };

    router.events.on('routeChangeStart', onRouteChangeStart);
    router.events.on('routeChangeComplete', onRouteChangeComplete);

    return () => {
      router.events.off('routeChangeStart', onRouteChangeStart);
      router.events.off('routeChangeComplete', onRouteChangeComplete);

      router.beforePopState(() => true);
    };
  }, [router]);
};

const stripLocale = (url: string, locale: string) => {
  if (url === `/${locale}`) return '/';

  if (url.startsWith(`/${locale}/`)) {
    return url.slice(locale.length + 1)!;
  }

  return url;
};
